import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withOpoCaseRoot = getWithRootPathGetter('/caseservice/cases/opo');

export const opoCaseApiPaths = {
  opoCases: withOpoCaseRoot(''),
  opoCaseById: withOpoCaseRoot('/:caseId'),
  opoCaseCreateDraft: withOpoCaseRoot('/create-draft'),
  opoCaseDonorData: withOpoCaseRoot('/:caseId/donor-data'),
} as const;

export const getOpoCaseApiUrl = {
  opoCases: () => opoCaseApiPaths.opoCases,
  opoCaseById: (caseId: string) => replacePathParams(opoCaseApiPaths.opoCaseById, { caseId }),
  opoCaseCreateDraft: () => opoCaseApiPaths.opoCaseCreateDraft,
  opoCaseDonorData: (caseId: string) => replacePathParams(opoCaseApiPaths.opoCaseDonorData, { caseId }),
};
